<template>
    <el-drawer
        class="drawer"
        :title="detailData.title"
        :visible.sync="detailParam.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <div class="drawer-body">
                    <el-form ref="detailData" :model="detailData" :rules="detailRule" size="small">
                        <el-form-item label="转移到：">
                            <el-radio-group v-model="detailData.model.rule">
                                <el-radio-button :label="1">公海</el-radio-button>
                                <el-radio-button :label="2">成员</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <template v-if="detailData.model.rule == 1">
                            <el-form-item
                                prop="row.id"
                                :rules="{ required: true, message: ' ', trigger: 'change' }"
                            >
                                <el-select v-model="detailData.row.id">
                                    <el-option
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        v-for="item in seaData.list"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                        <template v-if="detailData.model.rule == 2">
                            <el-form-item
                                prop="row.user_id"
                                :rules="{ required: true, message: ' ', trigger: 'change' }"
                            >
                                <el-select v-model="detailData.row.user_id">
                                    <el-option
                                        :key="item.user_id"
                                        :label="item.name"
                                        :value="item.id"
                                        v-for="item in userData.list"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="small"
                                :loading="detailData.loading.submit"
                                @click="SubmitDetail('detailData')"
                                >保 存</el-button
                            >
                            <el-button size="small" @click="detailParam.visible = false"
                                >取 消</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { UserData } from '@/plugin/User'
export default {
    inject: ['reload'],
    mixins: [UserData],
    props: ['detailParam'],
    data() {
        return {
            seaData: {
                list: [],
                pages: {
                    page: 1,
                    pagesize: 9999,
                    total: 0
                }
            },
            userData: {
                list: [],
                pages: {
                    page: 1,
                    pagesize: 9999
                }
            },
            detailData: {
                title: '转移客户',
                loading: {
                    form: false,
                    submit: false
                },
                model: {
                    rule: 1
                },
                row: {
                    rule: 1,
                    id: null,
                    user_id: null
                }
            },
            detailRule: {}
        }
    },
    created() {
        this.$nextTick(() => {
            this.GetSea()
            this.GetUser()
        })
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {
        // 公海列表
        GetSea() {
            this.detailData.loading.form = true
            this.$request({
                url: '/api/v1/customer_sea',
                params: {
                    order: 'asc',
                    ...this.seaData.pages
                }
            }).then(res => {
                if (!res.status) {
                    this.detailData.loading.form = false
                    this.seaData.list = res.data.list
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        // 用户列表
        GetUser() {
            this.detailData.loading.form = true
            this.GetUserData().then(res => {
                this.detailData.loading.form = false
                this.userData.list = res.list
            })
        },
        // 转移客户
        SubmitDetail(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$confirm('客户转移后，将不拥有该客户管理权限, 是否继续?', '警告', {
                        confirmButtonText: '确 定',
                        cancelButtonText: '取 消',
                        type: 'warning'
                    })
                        .then(() => {
                            this.detailData.loading.submit = true
                            this.$request({
                                url: '/api/v1/transfercustomer',
                                params: {
                                    sea_id: this.detailData.row.id,
                                    user_id: this.detailData.row.user_id,
                                    customers: JSON.stringify(this.detailParam.customers)
                                }
                            }).then(res => {
                                this.detailData.loading.submit = false
                                this.$message({
                                    message: res.message || (res.status ? '操作失败' : '操作成功'),
                                    type: res.status ? 'error' : 'success'
                                })
                                if (!res.status) {
                                    this.reload()
                                }
                            })
                        })
                        .catch(() => {})
                }
            })
        },
        ResetDetail(formName) {
            this.$refs[formName].resetFields()
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
</style>
